<template>
  <div>
    <div class="pane-group">
      <div class="pane-sm" >
        
        <h5>Select Location</h5>
        <nav-item v-for="(loc, i) in $locations" v-on:click="selectReport(loc)" 
        :class="loc === selectedLocation ? 'active' : ''" :key="i"
        >{{loc}}</nav-item>
        
        <h5>Select Date Period</h5>
        <nav-item class="active" v-on:click="selectReport('RCGB')">Today</nav-item>
        <nav-item class="" v-on:click="selectReport('RMGB')">Yesterday</nav-item>
        <nav-item class="" v-on:click="selectReport('WGB')">This Week</nav-item>
        <nav-item class="" v-on:click="selectReport('WGB')">Last Week</nav-item>
        
      </div>
      <div class="pane">
        <h1>{{selectedLocation}} POS Raw Transactions</h1>

        <BasicTableComponent :list="list" :formatters="listFormatters" :titles="listTitles"/>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable indent, block-spacing */
/* global axios */
export default {
  name: 'POSRawTransactions',
  async created () {
    await this.selectReport(this.selectedLocation)
  },
  data () { return {
      selectedLocation: 'RCGB', 
      list: [],
      listFormatters: {
        'settlement_date' : ['d', 'YYYY-MM-DD'], 
        'transaction_date' : ['d', 'ddd YYYY-MM-DD h:mm:ss a'], 
        'batch_number': ['n', '0']
      },
      listTitles: {}
    } 
  },
  methods: {
    selectReport: async function (location) {
      this.list = [];
      this.selectedLocation = location;
      let response = await i_axios.post('/Reports/getRawPOSTransactions', { location })
      this.list = response.data;
    },
  },
}
</script>

<style>
  
</style>
